<template>
    <section class="tables new-updated-design px-0 px-md-0 pt-4 pt-md-0">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card property-list-detail">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title m-0">{{ $t('property_detail.Property_Detail') }}</h4>
                    </div>
                    <div class="card-body overflow-hidden">
                        <div class="row row-border">
                            <div class="col-sm-6 col-md-4">
                                <p><span class="font-weight-bolder">{{ $t('properties_list.Property_Type') }}:</span> {{
                                    propertyData.accommodation_type }}
                                    ({{ $t('property_detail.' + propertyData.property_type) }}) </p>
                                <p><span class="font-weight-bolder">{{ $t('properties_list.place') }}:</span> {{
                                    propertyData.place_type }}</p>
                                <p><span class="font-weight-bolder">{{ $t('properties_list.city') }}:</span> {{
                                    propertyData.city }}</p>
                                <!-- <p><span class="font-weight-bolder">{{ $t('properties_list.state') }}:</span> {{
                                    propertyData.state }}</p> -->
                                <p><span class="font-weight-bolder">{{ $t('property_detail.Country') }}:</span> {{
                                    propertyData.country }}</p>
                                <p><span class="font-weight-bolder">{{ $t('property_detail.Guests') }}:</span> {{
                                    propertyData.max_guests }}</p>
                            </div>
                            <div class="col-sm-6 col-md-4">
                                <p><span class="font-weight-bolder">{{ $t('property_detail.bedrooms') }}:</span> {{
                                    propertyData.num_bedrooms }}</p>
                                <p><span class="font-weight-bolder">{{ $t('property_detail.Bedroom_Amenities')
                                }}:</span>
                                    {{ bedroomAmenitiesDisplay }}
                                </p>
                                <p><span class="font-weight-bolder">{{ $t('property_detail.bathrooms') }}:</span> {{
                                    propertyData.num_bathrooms }}</p>
                                <p><span class="font-weight-bolder">{{ $t('property_detail.Bathroom_Amenities')
                                }}:</span>
                                    {{ bathroomAmenitiesDisplay }}
                                </p>
                                <p><span class="font-weight-bolder">{{ $t('property_detail.min_stay')
                                }}:</span>{{ minStayUnit }}
                                </p>
                                <p><span class="font-weight-bolder">{{ $t('property_detail.max_stay') }}:</span>
                                    {{ maxStayUnit }}
                                </p>
                                <p v-if="propertyData.price_per_month"><span class="font-weight-bolder">{{
                                    $t('property_detail.price_per_month') }}:</span> ${{
                                            propertyData.price_per_month }}</p>
                                <p v-else><span class="font-weight-bolder">{{ $t('property_detail.Price') }}:</span> ${{
                                    propertyData.price }}</p>
                            </div>
                            <div class="col-sm-6 col-md-4">
                                <p><span class="font-weight-bolder">{{ $t('property_detail.wifi') }}:</span> {{
                                    propertyData.wifi_available === 1 ? $t('property_detail.yes') :
                                    $t('property_detail.no') }}</p>
                                <p><span class="font-weight-bolder">{{ $t('property_detail.kitchen') }}:</span> {{
                                    propertyData.kitchen_available === 1 ? $t('property_detail.yes') :
                                    $t('property_detail.no') }}</p>
                                <p><span class="font-weight-bolder">{{ $t('property_detail.tv') }}:</span> {{
                                    propertyData.tv_available === 1 ? $t('property_detail.yes') :
                                    $t('property_detail.no') }}</p>
                                <p><span class="font-weight-bolder">{{ $t('property_detail.Description') }}:</span> {{
                                    propertyData.property_description }}</p>
                            </div>
                        </div>
                        <div class="row mt-4 row-border">
                            <div class="col-md-12">
                                <!-- Images Section -->
                                <div class="row">
                                    <div class="col-sm-6 col-md-4">
                                        <h5>{{ $t('property_detail.property_owner_details') }}</h5>
                                        <p><span class="font-weight-bolder">{{ $t('register.name') }}:</span> {{
                                            propertyData.user.name }}
                                        </p>
                                        <p><span class="font-weight-bolder">{{ $t('login.email') }}:</span> {{
                                            propertyData.user.email }}
                                        </p>
                                        <p><span class="font-weight-bolder">{{ $t('register.phone') }}:</span> {{
                                            propertyData.user.mobile_phone }}</p>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <h5>{{ $t('Propertis.House_Rules') }}</h5>
                                        <!-- <p><span class="font-weight-bolder">{{ $t('Propertis.Check_in_after') }}:</span>
                                            {{ formatTime(propertyData.checkin_after) }}
                                        </p>
                                        <p><span class="font-weight-bolder">{{ $t('Propertis.Check_out_before')
                                                }}:</span> {{ formatTime(propertyData.checkout_before) }}
                                        </p> -->
                                        <p><span class="font-weight-bolder">{{ $t('Propertis.Children') }}:</span> {{ translatePolicy(propertyData.children, 'Children') }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('Propertis.Events') }}:</span> {{ translatePolicy(propertyData.Events, 'Events') }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('Propertis.Pets') }}:</span> {{ translatePolicy(propertyData.Pets, 'Pets') }}</p>
                                        <p><span class="font-weight-bolder">{{ $t('Propertis.Smoking') }}:</span> {{ translatePolicy(propertyData.Smoking, 'Smoking') }}</p>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <h5>{{ $t('Propertis.Damage_and_incidentals') }}</h5>
                                        <p><span class="font-weight-bolder"></span>{{ $t('Propertis.demage_responsoble')
                                        }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4 row-border property-discounts-data">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-sm-6 col-md-4">
                                        <template v-if="hasDiscount">
                                            <h5>{{ $t('discounts.available_discounts') }}:</h5>
                                            <div>
                                                <p class="property-discounts">{{ hasDiscount }}</p>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-md-12">
                                <!-- Images Section -->
                                <h5>{{ $t('property_detail.Property_Images') }}</h5>
                                <div class="row col-md-12 property-images">
                                    <div v-for="(imagePreview, index) in propertyData.photos" :key="index"
                                        class="image-holder">
                                        <img :src="imagePreview.path" :alt="$t('property_detail.Property_Images')">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-4 align-items-center">
                            <div class="col-6 status-approve">
                                <h5 class="mb-2">{{ $t('property_detail.Status') }}:</h5>

                                <!-- If approved, show text -->
                                <div v-if="propertyData.approve">
                                    <span
                                        style="background-color: #28a745; color: #fff; padding: 5px 10px; border-radius: 5px; font-weight: bold; display: inline-block;">
                                        {{ $t('property_detail.approved') }}
                                    </span>
                                </div>

                                <!-- If not approved, show approve button -->
                                <!-- <button v-else class="btn btn-success" @click="approveProperty(propertyData.id)">
                                    {{ $t('property_detail.Approve') }}
                                </button> -->
                                <button v-else class="btn btn-success btn-sm" @click="approveProperty(propertyData.id)"
                                    :disabled="submitting">
                                    <span v-if="submitting">{{ $t('common.submitting') }}</span>
                                    <span v-else>{{ $t('property_detail.Approve') }}</span>
                                </button>
                            </div>
                            <div class="col-6 inactive-btn">
                                <!-- <button v-if="propertyData.approve" class="btn btn-success"
                                    @click="inActiveProperty(propertyData.id)">{{
                                        $t('In-Active') }}</button> -->
                                <button v-if="propertyData.approve" class="btn btn-success btn-sm"
                                    @click="inActiveProperty(propertyData.id)" :disabled="submitting">
                                    <span v-if="submitting">{{ $t('common.submitting') }}</span>
                                    <span v-else>{{ $t('property_detail.in_active') }}</span>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
import Vue from "vue";
import API from '@/api'

export default {
    name: 'attendess',
    data() {
        return {
            propertyData: {
                city: "",
                // state: "",
                country: "",
                price: "",
                max_guests: "",
                num_bedrooms: "",
                num_bathrooms: "",
                propertyType: "",
                accommodation_type: "",
                wifiAvailable: "",
                kitchen: "",
                tv: "",
                description: "",
                imagePreviews: [],
                id: "",
                approve: "",
                flashdiscount: "",
                discounts: {
                    fivemonthsdis: null,
                    sixmonthsdis: null,
                    sevenmonthsdis: null,
                    eightmonthsdis: null,
                },
            },
            minStay: "",
            minStayUnit: "",
            maxStay: "",
            maxStayUnit: "",
            submitting: false,
        }
    },
    methods: {
        translatePolicy(value, category) {
            if (!value) return this.$t('common.none');
            const normalizeKey = (str) => {
                if (!str) return 'Not_Allowed';
                const lower = str.toString().toLowerCase().trim();
                if (lower === 'yes' || lower === '1') return 'Allowed';
                if (lower === 'no' || lower === '0') return 'Not_Allowed';
                return str
                    .trim()
                    .replace(/\s+/g, '_')
                    .replace(/Allowd/g, 'Allowed')
                    .replace(/[^a-zA-Z0-9:()_-]/g, '');
            };
            const normalizedKey = normalizeKey(value);
            const translationKey = `Propertis.Policies.${category}.${normalizedKey}`;
            if (this.$te(translationKey)) {
                return this.$t(translationKey);
            }
            const lower = value.toString().toLowerCase();
            if (lower.startsWith('allowed')) {
                const prefix = this.$t('common.allowed');
                const detail = value.split(':').slice(1).join(':').trim();
                return detail ? `${prefix}: ${detail}` : prefix;
            }
            if (
                lower === 'not allowed' ||
                lower === 'not_allowd' ||
                lower === 'not_allowed' ||
                lower === 'no' ||
                lower === '0'
            ) {
                return this.$t('common.not_allowed');
            }
            if (lower === 'yes' || lower === '1') {
                return this.$t('common.allowed');
            }
            return value;
        },
        convertNightsToUnit(nightCount) {
            if (nightCount % 30 === 0) {
                return { value: nightCount / 30, unit: this.$t('common.months_count', { n: nightCount / 30 }) };
            } else if (nightCount % 7 === 0) {
                return { value: nightCount / 7, unit: this.$t('common.weeks_count', { n: nightCount / 7 }) };
            } else {
                return { value: nightCount, unit: this.$t('common.days_count', { n: nightCount }) };
            }
        },

        getProperty() {
            const id = sessionStorage.getItem('propertyId');
            API.getProperty(id, res => {
                // console.log('API response:', res.data);
                this.propertyData = res.data.data;
                if (res.data.discounts) {
                    this.propertyData.discounts = res.data.discounts;
                }
                if (res.data.flashdiscount) {
                    this.propertyData.flashdiscount = res.data.flashdiscount;
                }

                const minUnitValue = this.convertNightsToUnit(this.propertyData.min_night_stay);
                this.minStay = minUnitValue.value;
                this.minStayUnit = minUnitValue.unit;

                // set max duration
                const maxUnitValue = this.convertNightsToUnit(this.propertyData.max_night_stay);
                this.maxStay = maxUnitValue.value;
                this.maxStayUnit = maxUnitValue.unit;
            }, err => {
                console.log(err)
            })
        },
        approveProperty(id) {
            this.submitting = true;

            API.approveProperty(id, res => {
                this.submitting = false;

                if (res.status == 200) {
                    this.propertyData.approve = 1;
                    this.$swal({
                        icon: 'success',
                        type: 'success',
                        title: this.$t('alerts.success'),
                        text: res.data.message,
                        confirmButtonText: this.$t('sweetalert.OK'),
                    });
                } else {
                    this.$swal({
                        icon: 'error',
                        type: 'error',
                        title: this.$t('sweetalert.Oops'),
                        text: res.message,
                        confirmButtonText: this.$t('sweetalert.OK'),
                    });
                }
            }, err => {
                this.submitting = false;
                console.log(err);
            });
        },

        inActiveProperty(id) {
            this.submitting = true;

            API.inActiveProperty(id, res => {
                this.submitting = false;

                if (res.status == 200) {
                    this.propertyData.approve = 0;
                    this.$swal({
                        icon: 'success',
                        type: 'success',
                        title: this.$t('alerts.success'),
                        text: this.$t('property_detail.property_inactive_success'),
                        confirmButtonText: this.$t('sweetalert.OK'),
                    });
                } else {
                    this.$swal({
                        icon: 'error',
                        type: 'error',
                        title: this.$t('sweetalert.Oops'),
                        text: res.message,
                        confirmButtonText: this.$t('sweetalert.OK'),
                    });
                }
            }, err => {
                this.submitting = false;
                console.log(err);
            });
        },
        formatTime(time) {
            const [hours, minutes] = time.split(':').map(Number);

            const date = new Date();
            date.setHours(hours);
            date.setMinutes(minutes);
            date.setSeconds(0);
            date.setMilliseconds(0);
            const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
            const formattedHours = date.getHours() % 12 || 12;
            const formattedMinutes = date.getMinutes().toString().padStart(2, '0');

            return `${formattedHours}:${formattedMinutes} ${ampm}`;
        },
    },

    mounted() {
        this.getProperty();
    },
    components: {},
    computed: {
        // hasDiscount() {
        //     // Check flash discount first
        //     if (this.propertyData.flashdiscount &&
        //         this.propertyData.flashdiscount.discount_percentage &&
        //         !this.propertyData.flashdiscount.is_expired) {
        //         // return `${this.propertyData.flashdiscount.discount_percentage}% Flash Discount Available`;
        //         return this.$t('discounts.flash_discount_available', { percentage: this.propertyData.flashdiscount.discount_percentage });
        //     }

        //     // Check regular discounts
        //     const discounts = this.propertyData.discounts || {};
        //     const discountMessages = [];
        //     // Weekly discounts
        //     if (discounts.oneweekdisc) {
        //         console.log('1 week discount:', discounts.oneweekdisc + '%');
        //         discountMessages.push(`${discounts.oneweekdisc}% for 1 week`);
        //     }
        //     if (discounts.twoweekdisc) {
        //         console.log('2 weeks discount:', discounts.twoweekdisc + '%');
        //         discountMessages.push(`${discounts.twoweekdisc}% for 2 weeks`);
        //     }
        //     if (discounts.threeweekdisc) {
        //         console.log('3 weeks discount:', discounts.threeweekdisc + '%');
        //         discountMessages.push(`${discounts.threeweekdisc}% for 3 weeks`);
        //     }

        //     // Monthly discounts
        //     if (discounts.onemonthdis) {
        //         console.log('1 month discount:', discounts.onemonthdis + '%');
        //         discountMessages.push(`${discounts.onemonthdis}% for 1 month`);
        //     }
        //     if (discounts.twomonthsdis) {
        //         console.log('2 months discount:', discounts.twomonthsdis + '%');
        //         discountMessages.push(`${discounts.twomonthsdis}% for 2 months`);
        //     }
        //     if (discounts.threemonthsdis) {
        //         console.log('3 months discount:', discounts.threemonthsdis + '%');
        //         discountMessages.push(`${discounts.threemonthsdis}% for 3 months`);
        //     }
        //     if (discounts.fourmonthsdis) {
        //         console.log('4 months discount:', discounts.fourmonthsdis + '%');
        //         discountMessages.push(`${discounts.fourmonthsdis}% for 4 months`);
        //     }
        //     if (discounts.fivemonthsdis) {
        //         console.log('5 months discount:', discounts.fivemonthsdis + '%');
        //         discountMessages.push(`${discounts.fivemonthsdis}% for 5 months`);
        //     }
        //     if (discounts.sixmonthsdis) {
        //         console.log('6 months discount:', discounts.sixmonthsdis + '%');
        //         discountMessages.push(`${discounts.sixmonthsdis}% for 6 months`);
        //     }
        //     if (discounts.sevenmonthsdis) {
        //         console.log('7 months discount:', discounts.sevenmonthsdis + '%');
        //         discountMessages.push(`${discounts.sevenmonthsdis}% for 7 months`);
        //     }
        //     if (discounts.eightmonthsdis) {
        //         console.log('8 months discount:', discounts.eightmonthsdis + '%');
        //         discountMessages.push(`${discounts.eightmonthsdis}% for 8 months`);
        //     }

        //     if (discountMessages.length > 0) {
        //         console.log('Available Discounts:', discountMessages.join(', '));
        //         return `${discountMessages.join(', ')}`;
        //     }

        //     console.log('No discounts available');
        //     return 'No discounts available for this property!!';
        // },
        hasDiscount() {
            // Check flash discount first
            if (this.propertyData.flashdiscount &&
                this.propertyData.flashdiscount.discount_percentage &&
                !this.propertyData.flashdiscount.is_expired) {
                return this.$t('discounts.flash_discount_available', { percentage: this.propertyData.flashdiscount.discount_percentage });
            }

            // Check regular discounts
            const discounts = this.propertyData.discounts || {};

            const discountMessages = [];

            // Weekly discounts
            if (discounts.oneweekdisc) {
                discountMessages.push(this.$t('discounts.one_week_stay', { percentage: discounts.oneweekdisc }));
            }
            if (discounts.twoweekdisc) {
                discountMessages.push(this.$t('discounts.two_week_stay', { percentage: discounts.twoweekdisc }));
            }
            if (discounts.threeweekdisc) {
                discountMessages.push(this.$t('discounts.three_week_stay', { percentage: discounts.threeweekdisc }));
            }

            // Monthly discounts
            if (discounts.onemonthdis) {
                discountMessages.push(this.$t('property_detail.one_month_stay', { percentage: discounts.onemonthdis }));
            }
            if (discounts.twomonthsdis) {
                discountMessages.push(this.$t('property_detail.two_month_stay', { percentage: discounts.twomonthsdis }));
            }
            if (discounts.threemonthsdis) {
                discountMessages.push(this.$t('property_detail.three_month_stay', { percentage: discounts.threemonthsdis }));
            }
            if (discounts.fourmonthsdis) {
                discountMessages.push(this.$t('property_detail.four_month_stay', { percentage: discounts.fourmonthsdis }));
            }
            if (discounts.fivemonthsdis) {
                discountMessages.push(this.$t('property_detail.five_month_stay', { percentage: discounts.fivemonthsdis }));
            }
            if (discounts.sixmonthsdis) {
                discountMessages.push(this.$t('property_detail.six_month_stay', { percentage: discounts.sixmonthsdis }));
            }
            if (discounts.sevenmonthsdis) {
                discountMessages.push(this.$t('property_detail.seven_month_stay', { percentage: discounts.sevenmonthsdis }));
            }
            if (discounts.eightmonthsdis) {
                discountMessages.push(this.$t('property_detail.eight_month_stay', { percentage: discounts.eightmonthsdis }));
            }

            if (discountMessages.length > 0) {
                return discountMessages.join(', ');
            }

            return this.$t('discounts.no_discounts_available');
        },
        bathroomAmenitiesDisplay() {
            if (Array.isArray(this.propertyData.bathroom_Amenities)) {
                return this.propertyData.bathroom_Amenities.map(amenity => this.$t('property_detail.' + amenity)).join(', ');
            } else if (typeof this.propertyData.bathroom_Amenities === 'string') {
                try {
                    const parsedAmenities = JSON.parse(this.propertyData.bathroom_Amenities);
                    if (Array.isArray(parsedAmenities)) {
                        return parsedAmenities.map(amenity => this.$t('property_detail.' + amenity)).join(', ');
                    }
                } catch (error) {
                    console.error("Error parsing bathroom amenities:", error);
                }
            }
            return this.propertyData.bathroom_Amenities;
        },
        bedroomAmenitiesDisplay() {
            if (Array.isArray(this.propertyData.bedroom_Amenities)) {
                if (this.propertyData.bedroom_Amenities.length === 0) {
                    console.log("Empty array detected");
                    return this.$t('common.none');

                }
                return this.propertyData.bedroom_Amenities.map(amenity => this.$t('property_detail.' + amenity)).join(', ');
            } else if (typeof this.propertyData.bedroom_Amenities === 'string') {
                try {
                    const parsedAmenities = JSON.parse(this.propertyData.bedroom_Amenities);
                    if (Array.isArray(parsedAmenities)) {
                        if (parsedAmenities.length === 0) {
                            console.log("Empty array detected after parsing");
                            return this.$t('common.none');
                        }
                        return parsedAmenities.map(amenity => this.$t('property_detail.' + amenity)).join(', ');
                    }
                } catch (error) {
                    console.error("Error parsing bedroom amenities:", error);
                }
            }
            return this.propertyData.bedroom_Amenities;
        }
    },
    created() {
        if (this.$route.params.id) {
            sessionStorage.setItem('propertyId', this.$route.params.id);
        }
    },
}

</script>
<style lang="css" scoped>
button.btn {
    padding: 10px !important;
    border-radius: 5px !important;
    font-size: 16px !important;
    line-height: 1 !important;
    height: max-content !important;
}
</style>
<style>
.property-list-detail .card {
    border: 0;
}

.property-list-detail .card .card-header {
    background: #70D3FF;
}

.property-list-detail .card .card-header h4.card-title {
    color: #fff;
    font-size: 24px;
    line-height: 1.2;
}

.property-list-detail .card .card-body {
    padding: 25px 0;
}

.property-list-detail .card .card-body .row-border {
    border-bottom: 1px solid #D6D6D6;
    margin: 0;
}

.property-list-detail .card .card-body .row-border .col-md-4 {
    padding-left: 0;
}

.property-list-detail .card .card-body .row-border .col-md-4 p {
    color: #717171;
    font-size: 14px;
    line-height: 1.3;
    margin-bottom: 15px;
}

.property-list-detail .card .card-body .row-border .col-md-4 p span {
    color: #333;
}

.property-list-detail .card .card-body .row-border .col-md-4 h5,
.property-list-detail .card .card-body h5 {
    margin-bottom: 20px;
    font-size: 18px;
    color: #333;
}

.property-images {
    gap: 15px;
    margin-bottom: 20px;
}

.property-images .image-holder {
    width: 100%;
    max-width: 180px;
}

.property-images .image-holder img {
    width: 100%;
    object-fit: cover;
    border-radius: 10px;
    height: 160px;
}

.inactive-btn {
    text-align: right;
}

.inactive-btn button.btn-success {
    margin-left: auto;
    width: auto;
    height: 50px;
    font-size: 18px;
}
</style>